export function isLast(selected, manual_action_executions) {
  return selected.index === manual_action_executions.length - 1
}
